module.exports = __webpack_public_path__ + "static/media/avanza@3x.cf0a80f0.jpg";